import React from "react";
import "./Loading.css";

const div = () => {
  return (
    <div className="loading">
      <div> </div>
    </div>
  );
};

export default div;
